"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcknowledgmentDTO = void 0;
class AcknowledgmentDTO {
}
exports.AcknowledgmentDTO = AcknowledgmentDTO;
//# sourceMappingURL=Ack.js.map